(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global['aecore-brenchInfo'] = factory());
}(this, (function () { 'use strict';

  var index = {
    getParamsByKey (ParmasKey) {
      let h = decodeURIComponent(window.location.search);
      let keyIndex = h.indexOf(`${ParmasKey}=`);
      let nh = h.substring(keyIndex + ParmasKey.length + 1, h.length);
      let values = [];
      for (let w of nh) {
        if (['?', '&'].indexOf(w) === -1) {
          values.push(w);
        } else {
          break
        }
      }
      let keyValue = values.join('');
      if (keyValue === 'null') return null
      if (keyValue === 'undefined') return void(0)
      if (keyValue.startsWith('{') && keyValue.endsWith('}')) {
        try {
          return JSON.parse(keyValue)
        } catch (error) {
          return new Object()
        }
      }
      if (keyValue.startsWith('[') && keyValue.endsWith(']')) {
        try {
          return JSON.parse(keyValue)
        } catch (error) {
          return new Array(0)
        }
      }
      if (keyValue === 'true' || keyValue === 'false') return keyValue === 'true'
      if (new RegExp(/^\d{1,}$/).test(keyValue)) return Number(keyValue)
      return new String(keyValue)
    }
  };

  return index;

})));
